import groq from 'groq';

export const PERMISSIONS_QUERY = groq`
  *[_type == "permissions" && isActive == true][0] {
    _id,
    home {
      show,
      showInHeader,
      showInFooter
    },
    companies {
      show,
      showInHeader,
      showInFooter
    },
    aboutUs {
      show,
      showInHeader,
      showInFooter
    },
    ourValues {
      show,
      showInHeader,
      showInFooter
    },
    objective {
      show,
      showInHeader,
      showInFooter
    },
    motion {
      show,
      showInHeader,
      showInFooter
    },
    ourClients {
      show,
      showInHeader,
      showInFooter
    },
    news {
      show,
      showInHeader,
      showInFooter
    },
    contactUs {
      show,
      showInHeader,
      showInFooter
    },
    isActive
  }
`;
